package com.essntl.features.file.ui.essntlgallery

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.file.domain.model.FileModel
import com.essntl.uikit.components.toggle.TabState
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

data class EssntlGalleryState(
    val getAllImages: State<List<FileModel>> = State(),
    val galleryType: Entity? = null,
    val selectedTabIndex: Int = galleryType?.index ?: 0,

    val tabItems: List<TabState> = when (galleryType) {
        Entity.SERVICES -> listOf(
            Entity.SERVICES.toTabState(),
        )

        Entity.PROPOSAL_COVER -> listOf(
            Entity.PROPOSAL_COVER.toTabState(),
        )

        Entity.TA_LOGOS -> listOf(
            Entity.TA_LOGOS.toTabState(),
        )

        Entity.SUPPLIER_LOGOS -> listOf(
            Entity.SUPPLIER_LOGOS.toTabState(),
        )

        else -> listOf(
            Entity.SERVICES.toTabState(),
            Entity.PROPOSAL_COVER.toTabState(),
            Entity.TA_LOGOS.toTabState(),
            Entity.SUPPLIER_LOGOS.toTabState(),
        )
    },

    ) {
    enum class Entity(val index: Int) {
        SERVICES(0),
        PROPOSAL_COVER(1),
        TA_LOGOS(2),
        SUPPLIER_LOGOS(3);

        override fun toString(): String {
            return when (this) {
                SERVICES -> "Services"
                PROPOSAL_COVER -> "Proposal Cover"
                TA_LOGOS -> "TA Logos"
                SUPPLIER_LOGOS -> "Supplier Logos"
            }
        }

        fun toTabState(): TabState {
            return TabState(index = index, text = toString())
        }

        fun entityType(): String {
            return when (this) {
                SERVICES -> "service"
                PROPOSAL_COVER -> "proposal"
                TA_LOGOS -> "travel_agent"
                SUPPLIER_LOGOS -> "supplier"
            }
        }
    }
}

@Composable
fun EssntlGalleryState.rememberAllImagesSorted(searchText: String = ""): List<FileModel> =
    remember(
        getAllImages,
        searchText,
    ) {
        getAllImages
            .data
            .orEmpty()
            .filter { fileModel ->
                searchText.isBlank() || fileModel.keywords
                    .orEmpty()
                    .any { keyword -> keyword.lowercase().contains(searchText.lowercase()) }
            }.sortedByDescending { fileModel ->
                try {
                    LocalDate.parse(fileModel.createdAt.substring(0, 10))
                } catch (e: Exception) {
                    // If the date is invalid, sort it to the top
                    println("Invalid date: ${fileModel.createdAt}")
                    Clock.System.now().toLocalDateTime(TimeZone.UTC).date
                }
            }
    }